<template>
  <div class="content">
    <base-alert v-model="$store.state.video.alert.visible" :variant="$store.state.video.alert.variant">
      {{ $store.state.video.alert.text }}
    </base-alert>
    <router-view></router-view>
  </div>
</template>

<script>
/* import routeHelpers from '@/router/routeHelpers' */
import BaseAlert from '@/components/base/ui/BaseAlert.vue'
import layoutMixin from '@/mixins/layout.mixin'

export default {
  name: 'VideoLayout',
	mixins: [layoutMixin],
  components: {
    BaseAlert
  },
  data () {
    return {
      locale: 'es',
      sidebar: {
        show: false,
        video: false,
        audio: false
      }
    }
  },
  watch: {
    // locale (val) {
    //   this.$i18n.locale = val
    // }
  },
  methods: {
    setLocale: function (listlocale) {
      // this.locale = listlocale
      this.$i18n.locale = listlocale
    },
    showVideo () {
      this.sidebar.video = true
      document.getElementById('rightMenu').style.display = 'block'
    },
    hideVideo () {
      this.sidebar.video = false
    },
    setVideoQualityHigh () {
      this.$store.commit('setVideoQuality', 1)
    },
    setVideoQualityMedium () {
      this.$store.commit('setVideoQuality', 2)
    },
    setVideoQualityLow () {
      this.$store.commit('setVideoQuality', 3)
    },
    muteVideo () {
      this.$store.commit('disableVideo')
    },
    shareScreen () {
      this.$store.commit('toggleShareScreen')
    }
  },
  created () {
    /* setTimeout(() => {
      const chatbotIframe = document.getElementById('chat-application')
      if (chatbotIframe) {
        chatbotIframe.style.display = 'none'
      }
			document.querySelector('#smartsupp-widget-container > div').style.display = 'none'
    }, 2000) */
  }
}
</script>

<style>
@import "~/static-appopensalud/css/general.css";
@import "~/static-appopensalud/css/navbar.css";

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.dropdown-item img {
  margin-right:10px;
}
</style>



// WEBPACK FOOTER //
// src/components/video-launcher/VideoLayout.vue